export default {
  'nav.home': 'Home',
  'nav.datasets': 'Datasets',
  'nav.docs': 'Docs',
  'nav.dataPrepare': '数据准备',
  'nav.dataUpload': '数据上传',
  'nav.material': '知识库',
  'nav.field': '自定义字段',
  'nav.source': '来源配置',
  'nav.OpenSourceTools': 'Open Data Tools',
  'nav.dynamics': 'News',
  'nav.aboutUs': 'About us',
  'nav.omnidocbench': 'Evaluation Ranking',

  'dataProcessing.title': 'Data Processing Steps',
  'dataProcessing.extraction': 'Data Extraction',
  'dataProcessing.labeling': 'Data Labeling',
  'dataProcessing.qualityAssessment': 'Data Quality Assessment',
  'dataProcessing.cleaning': 'Data Cleaning',
  'dataProcessing.visualization': 'Data Visualization',
  'dataProcessing.comingSoon': 'Coming Soon'
};
